import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'

export function Animate(props: { children: ReactNode; className?: string }) {
  return (
    <div className={cn('animate-in fade-in-0 slide-in-from-bottom-2 duration-250 ease-out', props.className)}>
      {props.children}
    </div>
  )
}
